<template>
  <div>
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row>
        <b-col cols="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("shaparak") }}
              </h1>
              <p class="font-size-large text-center dodger-blue-text">
                {{ $translate("youOnlyNeedToEnterYourCardNumber") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5" class="second-container-min-height">
          <shetab-stepper class="shaparakStepper"></shetab-stepper>
          <CreateShaparakTransaction v-if="getStepperPage === 'pageOne'" />
          <ShaparakFinal v-if="getStepperPage === 'pageTwo'" />
          <ShaparakResult v-if="getStepperPage === 'pageThree'" />
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import ShetabStepper from "@/components/ShetabStepper";
import ShaparakFinal from "@/components/Shaparak/ShaparakFinal";
import CreateShaparakTransaction from "@/components/Shaparak/CreateShaparakTranasction";
import ShaparakResult from "@/components/Shaparak/ShaparakResult";
import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
export default {
  name: "Shaparak",
  components: {
    ShaparakResult,
    CreateShaparakTransaction,
    ShaparakFinal,
    ShetabStepper,
  },
  data() {
    return {
      paymentId: null,
    };
  },
  computed: {
    ...mapGetters(["getStepperPage"]),
  },
  methods: {
    ...mapMutations(["setStepperPage", "setIsCompName"]),
  },
  created() {
    this.setIsCompName("shaparak");
    this.setStepperPage("pageOne");
    this.paymentId = this.$route.query.id;
    if (!this.paymentId) {
      alertHelper.paymentIdNotValidAlert();
    }
  },
};
</script>

<style scoped>
.shaparakStepper {
  padding-bottom: 30px;
}
</style>
